import React, {useEffect, useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {
    DEFAULT_DESIGN_INFO_FILTER_FIELD,
    DESIGN_INFO_FILTER_ATTRIBUTES,
    DESIGN_INFO_FILTER_FIELDS
} from "../../constants/design-info.constant";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const emptyFilterCriteria: any = {};
// let allFilterFields = _.groupBy(DESIGN_INFO_FILTER_FIELDS, 'group')['filter'];
let allFilterFields = DESIGN_INFO_FILTER_FIELDS;
const defaultSelectedField = DEFAULT_DESIGN_INFO_FILTER_FIELD;

const DesignInfoFilters = ({
                               designs = null,
                               allDesignInfo = null,
                               filterCriteria,
                               setFilterCriteria,
                               dataFetchInProgress = false,
                               showSecondaryFilters = true,
                               containerClass = '',
                               fieldClass = 'w-fit',
                               allFilterFields = DESIGN_INFO_FILTER_FIELDS,
                           }) => {
    const [initialStep, setInitialStep] = useState(true);
    const [designInfoFilterFields, setDesignInfoFilterFields] = useState(allFilterFields);

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            prepareAllFilterFields({});
        }
    }, [initialStep]);

    const prepareAllFilterFields = (existingFilterCriteria) => {
        const exitingFilterFields = [...designInfoFilterFields];
        const designInfoFilters = allDesignInfo?.filters;

        _.forEach(exitingFilterFields, (field) => {
            if (field.isDynamic) {
                // field.options = _.orderBy(designInfoFilters[field.attribute]?.options || [], 'label');
                let options = _.orderBy(designInfoFilters[field.attribute]?.options || [], 'label');

                if (field?.dependsOn && existingFilterCriteria.hasOwnProperty(field?.dependsOn) && existingFilterCriteria[field?.dependsOn]) {
                    options = _.filter(options, (option) => {
                        if (field?.dependsOn && existingFilterCriteria.hasOwnProperty(field?.dependsOn) && existingFilterCriteria[field?.dependsOn]) {
                            return option[field?.dependsOn] === existingFilterCriteria[field?.dependsOn];
                        } else {
                            return true;
                        }
                    });
                }

                field.options = options;
            }
        });

        setDesignInfoFilterFields(exitingFilterFields);
    }

    const handleFilterChanges = (event) => {
        let existingFilterCriteria = {...filterCriteria};
        existingFilterCriteria = handleFieldValueChanges(event, existingFilterCriteria);
        setFilterCriteria(existingFilterCriteria);

        setTimeout(() => {
            prepareAllFilterFields(existingFilterCriteria);
        }, 1);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
        prepareAllFilterFields(emptyFilterCriteria);
    }

    return (
        <>
            {designInfoFilterFields?.length > 0 &&
                <>
                    <div className="w-fit">
                        <div className={`flex justify-start w-full ${containerClass}`}>
                            <RenderFields
                                parentForm={filterCriteria}
                                handleDetailChanges={handleFilterChanges}
                                fieldList={_.filter(designInfoFilterFields, {group: 'filter'})}
                                enableEdit={true}
                                fieldClassName={`${fieldClass}`}/>

                            {!showSecondaryFilters &&
                                <div className="w-fit mt-10 mx-2">
                                    <button
                                        onClick={() => clearFilterCriteria()}
                                        className="button-gray-outline px-2 py-1">
                                        Clear Filters
                                    </button>
                                </div>
                            }
                        </div>

                        {showSecondaryFilters &&
                            <div className="flex justify-start w-full">
                                <RenderFields
                                    parentForm={filterCriteria}
                                    handleDetailChanges={handleFilterChanges}
                                    fieldList={_.filter(designInfoFilterFields, {group: 'flags'})}
                                    enableEdit={true}
                                    fieldClassName={`w-fit`}/>

                                <div className="w-fit mt-10 mx-2">
                                    <button
                                        onClick={() => clearFilterCriteria()}
                                        className="button-gray-outline px-2 py-1">
                                        Clear Filters
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </>
            }
        </>
    )
}

export default DesignInfoFilters
